module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"change_status_report":"Change of Status Report","start_date":"Start Date","end_date":"End Date","blood_type":"Blood Type","hospital":"Hospital Name","organ_code":"Organ Code"},"fr":{"change_status_report":"Change of Status Report","start_date":"Start Date","end_date":"End Date","blood_type":"Blood Type","hospital":"Hospital Name","organ_code":"Organ Code"}}')
  delete Component.options._Ctor
}
